@if (cameraLayoutOptionsContainer().optionType === "Livestream") {
	<sim-recorder-camera-fin
		[liveStreamCameraLayoutOptions]="liveStreamOptions()"
		[isSingleView]="isSingleView()"
		[screen]="liveStreamOptions().screens[screenIndex()]"
		[screenIndex]="screenIndex()"
		[screens]="liveStreamOptions().screens"
	/>
}

@if (cameraLayoutOptionsContainer().optionType === "Playback") {
	<sim-recording-archive-camera [screen]="playbackOptions().screens[screenIndex()]" [cameraLayoutOptions]="playbackOptions()" />
}
